export enum PsychometricAssessmentsTranslations {
  psychometricTestTitle = 'psychometricassessmentstranslations.psychometricTestTitle',
  psychometricTestResults = 'psychometricassessmentstranslations.psychometricTestResults',
  psychometricTestResultsUpperCase = 'psychometricassessmentstranslations.psychometricTestResultsUpperCase',
  psychometricTestNoConsentBoxValue = 'psychometricassessmentstranslations.psychometricTestNoConsentBoxValue',
}
